import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient) { }
  getLocations(): Observable<any> {
    const url = `${environment.apiOrigin}/api/locations`;
    return this.http.get(url);
  }

  getLocation(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/locations/${id}`;
    return this.http.get(url);
  }

  deleteLocation(id: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/locations/${id}`;
    return this.http.delete(url);
  }

  saveLocation(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/locations`;
    if (value.id) {
      return this.http.post(url, value);
    } else {
      return this.http.put(url, value);
    }
  }
}
